/** Relie l'échelle partagée au brouillon du risque physique. */
import RiskScale from "@/components/risk-scale"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { PhysicalRisk } from "../model/physical-risk.types"
import physicalRiskStore from "../model/physical-risk.store"

interface Props {
  id: "severity" | "frequency"
  isReadonly?: boolean
  risk?: PhysicalRisk
}

export default function PhysicalRiskScale({ id, isReadonly, risk }: Props) {
  const dispatch = useAppDispatch()
  const draft = useAppSelector(physicalRiskStore.selectors.draft)
  const showCalculations = useAppSelector((state) => state._session.userOptions.risksShowCalculations)
  const displayedRisk = risk ?? draft

  return (
    <RiskScale
      scale={(id === "severity" ? displayedRisk.cSeverityScale : displayedRisk.cFrequencyScale) ?? []}
      value={displayedRisk[id]}
      showValues={Boolean(risk) || showCalculations}
      onChange={isReadonly || risk ? undefined : (value) => dispatch(physicalRiskStore.thunks.edit({ key: id, value }))}
    />
  )
}
